import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProposalsComponent } from '@teem/proposals-module/proposals.component';

const routes: Routes = [
	{
		path: '',
		component: ProposalsComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProposalsRoutingModule { }
